T.HowTo = Class(
	/**
	 * @lends {T.HowTo#}
	 */
	{
		__construct( tasks, defaultTask, streetView, h2, h4, noVideo, key = '' ) {
			this.currentHowTo = defaultTask;
			this.streetView = streetView === true;
			this.tasks = tasks;
			this.noVideo = noVideo;

			let links = mkE({
				tag: 'div',
				className: 'how-to-links'
			});
			let images = mkE({
				tag: 'div',
				className: 'how-to-image'
			});
			tasks.forEach(task => {
				mkE({
					tag: 'a',
					id: 'how-to-link-' + task,
					className: task === defaultTask ? 'active' : '',
					els: [
						D.svgIcon(`task-${task}`),
						{
							tag: 'span',
							className: 'dot'
						},
						{
							tag: 'span',
							className: 'text',
							text: D.Lang.get('how-to.' + task + '.caption')
						}
					],
					onclick: D.closure(this, this.switchTask, task)
				}).append(links);

				let taskLang = 'en';
				if( D.LANG === 'lv' || D.LANG === 'lt' ) {
					taskLang = D.LANG;
				}
				let taskImage = task;
				if( this.streetView && ['matchmaker', 'explorer'].includes(taskImage) ) {
					taskImage += '-streetview';
				}

				mkE({
					tag: 'img',
					id: 'how-to-image-' + task,
					className: task === defaultTask ? 'active' : '',
					src: '/assets/images/how-to/slides/' + taskLang + '/' + taskImage + '.png',
					alt: D.Lang.get(`how-to.${task}.caption`, ''),
					attr: {
						srcset: '/assets/images/how-to/slides/' + taskLang + '/' + taskImage + '.png 1x, ' + '/assets/images/how-to/slides/' + taskLang + '/' + taskImage + '@2x.png 2x, ' + '/assets/images/how-to/slides/' + taskLang + '/' + taskImage + '@3x.png 3x',
						width: '317px',
						height: '632px'
					}
				}).append(images);
			});

			let suffix = '';
			if( this.streetView && ['matchmaker', 'explorer', 'detective', 'groupie'].includes(this.currentHowTo) ) {
				suffix = '.online';
			}

			this.node = mkE({
				tag: 'div',
				id: 'how-to-play-new',
				className: 'how-to-' + defaultTask,
				els: [
					{
						tag: 'div',
						className: 'how-to-main container',
						els: [
							{
								tag: 'div',
								className: 'question-top'
							},
							{
								tag: 'div',
								className: 'question-bottom'
							},
							h4 ? {
								tag: 'h4',
								text: h4
							} : '',
							h2 ? {
								tag: 'h2',
								text: h2
							} : '',
							this._main = mkE({
								tag: 'div',
								className: 'bs-row',
								els: [
									{
										tag: 'div',
										className: 'col-12 col-lg-2 order-0',
										els: [
											links
										]
									},
									{
										tag: 'div',
										className: 'col-12 col-lg-5 order-2 order-lg-1 image-col',
										ontouchstart: this.onTouchStart,
										ontouchend: this.onTouchEnd,
										els: [
											{
												tag: 'div',
												className: 'how-to-image-container',
												els: [
													images
												]
											}
										]
									},
									{
										tag: 'div',
										className: 'col-12 col-lg-5 order-1 order-lg-2 how-to-content-wrapper',
										ontouchstart: this.onTouchStart,
										ontouchend: this.onTouchEnd,
										els: [
											{
												tag: 'div',
												className: 'how-to-content',
												els: [
													{
														tag: 'div',
														className: 'how-to-tasks',
														els: [
															{
																tag: 'div',
																className: 'how-to-task',
																els: [
																	this.noVideo ? null : {
																		tag: 'div',
																		className: 'how-to-video',
																		els: [
																			{
																				tag: 'a',
																				onclick: this.openTaskVideo,
																				els: [
																					this._video = mkE({
																						tag: 'video',
																						src: `/assets/videos/how-to/${defaultTask}_sm.mp4?v=2`,
																						width: 328,
																						height: 328,
																						attr: {
																							preload: 'auto',
																							muted: true,
																							autoplay: true,
																							loop: true,
																							playsinline: true
																						},
																						oncanplaythrough: function () {
																							this.muted = true;
																							try {
																								this.play();
																							} catch( e ) {
																							}
																						}
																					})
																				]
																			}
																		]
																	},
																	{
																		tag: 'h3',
																		els: [
																			D.Lang.get('how-to.content.prefix') + ' ',
																			{
																				tag: 'span',
																				className: 'pink',
																				text: D.Lang.get('how-to.' + defaultTask + '.caption2')
																			}
																		]
																	},
																	{
																		tag: 'p',
																		text: D.Lang.get('how-to.' + defaultTask + '.description' + suffix)
																	}
																]
															}
														]
													}
												]
											}
										]
									}
								]
							})
						]
					}
				]
			});
		},

		openTaskVideo( e ) {
			let src = `/assets/videos/how-to/${this.currentHowTo}.mp4?v=2`;
			if( screen.width < 768 ) {
				if( this._video.src !== window.location.origin + src ) {
					this._video.src = src;
				}
				this._video.muted = false;
				this._video.autoplay = true;
				this._video.loop = false;
				if( this._video.readyState > 3 ) {
					this.onVideoCanPlay();
				} else {
					this._video.addEventListener('canplay', this.onVideoCanPlay);
				}
			} else {
				T.Popup.clip(src, 768, 768);
			}
		},

		onVideoCanPlay( e ) {
			this._video.removeEventListener('canplay', this.onVideoCanPlay);
			if( this._video.requestFullscreen ) {
				this._video.addEventListener('fullscreenchange', this.onFullscreenChange);
				this._video.requestFullscreen();
			} else if( this._video.mozRequestFullScreen ) {
				this._video.addEventListener('mozfullscreenchange', this.mozOnFullscreenChange);
				this._video.mozRequestFullScreen();
			} else if( this._video.webkitRequestFullScreen ) {
				this._video.addEventListener('webkitfullscreenchange', this.webkitOnFullscreenChange);
				this._video.webkitRequestFullScreen();
			} else if( this._video.webkitEnterFullscreen ) {
				this._video.addEventListener('webkitfullscreenchange', this.webkitOnFullscreenChange);
				this._video.webkitEnterFullscreen();
			}
		},

		onFullscreenChange( e ) {
			if( !document.fullscreenElement ) {
				this._video.muted = true;
				this._video.autoplay = true;
				this._video.loop = true;
				this._video.removeEventListener('fullscreenchange', this.onFullscreenChange);
			}
		},

		mozOnFullscreenChange( e ) {
			if( !document.mozFullscreenElement ) {
				this._video.muted = true;
				this._video.autoplay = true;
				this._video.loop = true;
				this._video.removeEventListener('mozfullscreenchange', this.mozOnFullscreenChange);
			}
		},

		webkitOnFullscreenChange( e ) {
			if( !document.webkitFullscreenElement ) {
				this._video.muted = true;
				this._video.autoplay = true;
				this._video.loop = true;
				this._video.removeEventListener('webkitfullscreenchange', this.webkitOnFullscreenChange);
			}
			this._video.play();
		},

		switchTask( task ) {
			let suffix = '';
			if( this.streetView && ['matchmaker', 'explorer', 'detective', 'groupie'].includes(task) ) {
				suffix = '.online';
			}
			let n = document.getElementById('how-to-play-new');
			removeClassName(n, 'how-to-' + this.currentHowTo);
			removeClassName(document.getElementById('how-to-link-' + this.currentHowTo), 'active');
			removeClassName(document.getElementById('how-to-image-' + this.currentHowTo), 'active');
			this.currentHowTo = task;
			addClassName(n, 'how-to-' + this.currentHowTo);
			const el = document.getElementById('how-to-link-' + this.currentHowTo);
			addClassName(el, 'active');
			addClassName(document.getElementById('how-to-image-' + this.currentHowTo), 'active');
			setNodeText(document.querySelector('.how-to-task .pink'), D.Lang.get('how-to.' + task + '.caption2'));
			setNodeText(document.querySelector('.how-to-task p'), D.Lang.get('how-to.' + task + '.description' + suffix));
			if( this._video ) {
				this._video.src = `/assets/videos/how-to/${this.currentHowTo}_sm.mp4?v=2`;
			}

			if( el.parentElement.scrollWidth - el.parentElement.clientWidth > 0 ) {
				el.parentElement.scroll(el.offsetLeft - el.clientWidth, 0)
			}
		},

		showNext() {
			let current = this.tasks.indexOf(this.currentHowTo);
			let next = current + 1;
			if( next === this.tasks.length ) {
				next = 0;
			}
			this.switchTask(this.tasks[next]);
		},

		showPrevious() {
			let current = this.tasks.indexOf(this.currentHowTo);
			let previous = current - 1;
			if( previous < 0 ) {
				previous = this.tasks.length - 1;
			}
			this.switchTask(this.tasks[previous]);
		},

		onShow() {

		},

		onLeave() {

		},

		onTouchStart( e ) {
			this.startX = e.changedTouches[0].screenX;
			this.startY = e.changedTouches[0].screenY;
		},

		onTouchEnd( e ) {
			const diffX = e.changedTouches[0].screenX - this.startX;
			const diffY = e.changedTouches[0].screenY - this.startY;
			const ratioX = Math.abs(diffX / diffY);
			const ratioY = Math.abs(diffY / diffX);
			const absDiff = Math.abs(ratioX > ratioY ? diffX : diffY);

			// Ignore small movements.
			if( absDiff < 30 ) {
				return;
			}

			if( ratioX > ratioY ) {
				if( diffX >= 0 ) {
					this.showPrevious();
				} else {
					this.showNext();
				}
			}
		}
	},
	mkE.Base
)